import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {AppConfigService} from "../../services/app-config.service";
import {tap} from "rxjs/operators";
import {IAppConfig} from "../../interfaces/IAppConfig";
import {PotentialEnvironments} from "../../consts/PotentialEnvironments";
import {EnvironmentType} from "../../enum/EnvironmentType";
import {MatToolbarModule} from "@angular/material/toolbar";
import {AsyncPipe} from "@angular/common";
import {PipesModule} from "../../pipes/pipes.module";
import {MatIcon} from "@angular/material/icon";
import {SideNavService} from "../../services/side-nav.service";
import {MatIconButton} from "@angular/material/button";
import {SupportRequestService} from "../../services/support-request.service";
import {MatBadge} from "@angular/material/badge";
import {MatDialog} from "@angular/material/dialog";
import {ReportGlossaryComponent} from "../dialogs/report-glossary/report-glossary.component";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'app-game-banner',
  standalone: true,
  templateUrl: './game-banner.component.html',
  imports: [
    MatToolbarModule,
    AsyncPipe,
    PipesModule,
    MatIcon,
    MatIconButton,
    MatBadge,
    MatTooltip
  ],
  styleUrls: ['./game-banner.component.scss']
})
export class GameBannerComponent implements OnInit, OnDestroy {

  public currentEnvironment: string = '';
  public appConfig$: Observable<IAppConfig> = this.appConfigService.appConfig$.pipe(tap((configP) => {
    this.determineEnvironment(configP.currentEnvironment);
  }));
  public assignedSupportRequestsCount$ = this.supportRequestService.mySupportRequests$;
  public sideNavState$ = this.sideNavService.sideNavState$;
  appConfigSub: Subscription | null = null;

  constructor(private sideNavService: SideNavService,
              private appConfigService: AppConfigService,
              private supportRequestService: SupportRequestService,
              private matDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.appConfigSub = this.appConfig$.subscribe();
  }

  ngOnDestroy(): void {
    if(this.appConfigSub) {
      this.appConfigSub.unsubscribe();
    }
  }

  private determineEnvironment(currentEnvironmentStringP: string) {
    const currentEnvironment = PotentialEnvironments.find((envP) => {
      return envP.type.toLowerCase() === currentEnvironmentStringP.toLowerCase();
    });

    if (currentEnvironment && currentEnvironment.type !== EnvironmentType.Production) {
      this.currentEnvironment = currentEnvironment.name;
    }
  }

  onSideNavToggle() {
    this.sideNavService.toggleDrawer();
  }

  openGlossary(): void {
    this.matDialog.open(ReportGlossaryComponent, {
      width: '800px',
      maxHeight: '80vh'
    });
  }
}
